import React from "react";
import ProjectRoutes from "./Routes";

function App() {
  return (
    <ProjectRoutes />
  );
}

export default App;
